import { all, fork } from "redux-saga/effects";
import SurveySaga from "./surveySaga";

export default function* rootSaga() {
  yield all([fork(SurveySaga)]);
}
